"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _require = require('./graphQueries'),
    getPlasmaQuery = _require.getPlasmaQuery,
    campaignPlasmaStatsQuery = _require.campaignPlasmaStatsQuery,
    campaignPublicStatsQuery = _require.campaignPublicStatsQuery,
    getPublicQuery = _require.getPublicQuery;

var _require2 = require('./parsers'),
    visitedListFromGraphToHashMap = _require2.visitedListFromGraphToHashMap,
    parseCampaignData = _require2.parseCampaignData;

var _require3 = require('./referralMap'),
    buildSubGraphWrapper = _require3.buildSubGraphWrapper;

var ReferralMap =
/*#__PURE__*/
function () {
  _createClass(ReferralMap, null, [{
    key: "getBusinessQuery",
    value: function getBusinessQuery(plasmaAddress) {
      var orderBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_timeStamp';
      var orderDirection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'desc';
      return "{\n      campaigns(where:{_owner: \"".concat(plasmaAddress, "\"}, orderBy: ").concat(orderBy, ", orderDirection: ").concat(orderDirection, "){\n          id\n          _n_unique_converters\n        }\n      }");
    }
  }, {
    key: "getCampaignLastActivity",
    value: function getCampaignLastActivity(address) {
      return "{\n          campaigns(where:{id:\"".concat(address, "\"}){\n            _updatedTimeStamp\n          }\n        }");
    }
  }]);

  function ReferralMap(_ref) {
    var request = _ref.request,
        _ref$publicAPIPath = _ref.publicAPIPath,
        publicAPIPath = _ref$publicAPIPath === void 0 ? 'subgraphs/name/2key' : _ref$publicAPIPath,
        _ref$plasmaAPIPath = _ref.plasmaAPIPath,
        plasmaAPIPath = _ref$plasmaAPIPath === void 0 ? 'subgraphs/name/plasma' : _ref$plasmaAPIPath;

    _classCallCheck(this, ReferralMap);

    this.graphAPI = function (query) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
      var requestType = {
        "public": publicAPIPath,
        plasma: plasmaAPIPath
      };
      return request(requestType[type] || requestType["public"], {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          query: query
        })
      }).then(function (data) {
        return data;
      });
    };
  }

  _createClass(ReferralMap, [{
    key: "fetchPromise",
    value: function fetchPromise(graphType, queryFunction, campaignWeb3Address, recordsToSkip) {
      return this.graphAPI(queryFunction(campaignWeb3Address, recordsToSkip), graphType).then(function (data) {
        if (process.env.EXECUTION_CONTEXT) {
          console.log("\n[SUCCESS] Type: ".concat(JSON.stringify(graphType), ", function: \n                  ").concat(JSON.stringify(queryFunction.name), ". Records to skip ").concat(recordsToSkip, ", \n                  campaignWeb3:").concat(campaignWeb3Address, " result set: ").concat(JSON.stringify(data), "."));
        }

        return data.data.campaigns ? data.data.campaigns[0] : JSON.stringify(data.data.campaigns);
      })["catch"](function (err) {
        console.log("\n[FAILED]: type: ".concat(JSON.stringify(graphType), ", function: \n              ").concat(JSON.stringify(queryFunction.name), ". Records to skip ").concat(recordsToSkip, ", \n              campaignWeb3: ").concat(campaignWeb3Address, " graphType, ").concat(JSON.stringify(graphType), " error messages: ").concat(err));
        return err;
      });
    }
  }, {
    key: "AsyncBuildRefGraph",
    value: function AsyncBuildRefGraph(_ref2) {
      var _this = this;

      var campaignWeb3Address = _ref2.campaignWeb3Address,
          campaignPlasmaAddress = _ref2.campaignPlasmaAddress,
          nodeToBuildGraphFrom = _ref2.nodeToBuildGraphFrom;
      return new Promise(
      /*#__PURE__*/
      function () {
        var _ref3 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(resolve, reject) {
          var visitArray, conversions, plasmaJoinsArray, rewards, campaignPOAAddress, plasmaURL, publicURL, promiseArray, graphResponses, plasmaVisits, maxPlasmaResults, maxPublicResults, plasmaIteration, publicIteration, iteratePlasma, iteratePublic, iteration, _iteration, publicResults, privateResults, firstReferrerInfo, _parseCampaignData, _parseCampaignData2, revJoinsByPlasma, users, campaignLastActivityAfterPublicResponse, _visitedListFromGraph, _visitedListFromGraph2, hashmapEdges, mutatedUsers, campaignLastActivityAfterPrivateResponse, visitsSubstruction, _buildSubGraphWrapper, _buildSubGraphWrapper2, buildSG, hoverByPlasma, stats, refGraphD3Input, refMapNodeCounter, paidClicksDownstream, unpaidClicksDownstream, approvedClicksDownstream, referrersDownstream, rejectedConversionsDownstream, maxChainLength, conversionsDownstream, nodesCounterFromGraph;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (process.env.EXECUTION_CONTEXT) {
                    console.log("BuildRefGraph parameters: CampaignWeb3Address-".concat(campaignWeb3Address, ", \n                CampaignPlasmaAddress").concat(campaignPlasmaAddress, ", \n                nodeToBuildGraphFrom").concat(nodeToBuildGraphFrom, "."));
                  }

                  visitArray = [];
                  conversions = [];
                  plasmaJoinsArray = [];
                  rewards = [];
                  campaignPOAAddress = campaignPlasmaAddress || campaignWeb3Address;
                  _context.prev = 6;
                  plasmaURL = 'plasma';
                  publicURL = 'public';
                  promiseArray = []; // Get stats from public and plasma endpoints

                  promiseArray.push(_this.fetchPromise(plasmaURL, campaignPlasmaStatsQuery, campaignPOAAddress, 0));
                  promiseArray.push(_this.fetchPromise(publicURL, campaignPublicStatsQuery, campaignWeb3Address, 0));
                  _context.next = 14;
                  return Promise.all(promiseArray);

                case 14:
                  graphResponses = _context.sent;
                  plasmaVisits = 0;
                  maxPlasmaResults = 0;
                  maxPublicResults = 0;

                  if (process.env.EXECUTION_CONTEXT) {
                    console.log("Graph response, meta object: ".concat(JSON.stringify(graphResponses), "."));
                  }

                  graphResponses.forEach(function (response) {
                    if (process.env.EXECUTION_CONTEXT) {// console.log('Response: ',JSON.stringify(response));
                      // console.log(`Stringify: ${JSON.stringify(response, null, 4)}`);
                    }

                    if (response != undefined) {
                      if (response._subgraphType === 'PLASMA') {
                        plasmaVisits = response._n_visits;
                        maxPlasmaResults = Math.max(response._n_visits || 0, response._n_conversions || 0, response._n_joins || 0, maxPlasmaResults || 0);
                      }

                      if (response._subgraphType === 'PUBLIC') {
                        maxPublicResults = Math.max(response._n_rewards || 0, response._n_conversions || 0, maxPublicResults || 0);
                      }
                    }
                  }); // let [plasmaResponse] = graphResponses.filter(value => {return value._subgraphType == 'PLASMA'});
                  // let [publicResponse] = graphResponses.filter(value => {return value._subgraphType == 'PUBLIC'});

                  plasmaIteration = 1000;
                  publicIteration = 100;
                  iteratePlasma = parseInt(maxPlasmaResults / plasmaIteration, 10) + 1;
                  iteratePublic = parseInt(maxPublicResults / publicIteration, 10) + 1;
                  promiseArray = [];

                  for (iteration = 0; iteration <= iteratePlasma; iteration += 1) {
                    promiseArray.push(_this.fetchPromise(plasmaURL, getPlasmaQuery, campaignPOAAddress, iteration * plasmaIteration));
                  }

                  for (_iteration = 0; _iteration <= iteratePublic; _iteration += 1) {
                    promiseArray.push(_this.fetchPromise(publicURL, getPublicQuery, campaignWeb3Address, _iteration * publicIteration));
                  }

                  _context.next = 29;
                  return Promise.all(promiseArray);

                case 29:
                  graphResponses = _context.sent;

                  if (process.env.EXECUTION_CONTEXT) {
                    console.log("Graph responses, all objects: ".concat(graphResponses, "."));
                  }

                  publicResults = [];
                  privateResults = [];
                  graphResponses.forEach(function (response) {
                    if (response != undefined) {
                      if (response._subgraphType === 'PUBLIC') {
                        publicResults.push(response);
                      } else if (response._subgraphType === 'PLASMA') {
                        privateResults.push(response);
                      }
                    }
                  }); // const publicResults = graphResponses.filter(response => response._subgraphType === 'PUBLIC'); //Not working!
                  // const privateResults = graphResponses.filter(response => response._subgraphType === 'PLASMA');

                  publicResults.forEach(function (result) {
                    conversions = _toConsumableArray(new Set([].concat(_toConsumableArray(conversions), _toConsumableArray(result._conversions))));
                    rewards = _toConsumableArray(new Set([].concat(_toConsumableArray(rewards), _toConsumableArray(result._rewards))));
                  });
                  privateResults.forEach(function (result) {
                    conversions = _toConsumableArray(new Set([].concat(_toConsumableArray(conversions), _toConsumableArray(result._conversions))));
                    visitArray = _toConsumableArray(new Set([].concat(_toConsumableArray(visitArray), _toConsumableArray(result._visitors))));
                    plasmaJoinsArray = _toConsumableArray(new Set([].concat(_toConsumableArray(plasmaJoinsArray), _toConsumableArray(result._joins))));
                  });
                  firstReferrerInfo = {
                    referrer: privateResults[0] ? privateResults[0]._plasmaRootNode.id : 0,
                    firstCampaignActivity: privateResults[0] ? privateResults[0]._timeStamp : 0
                  };
                  _parseCampaignData = parseCampaignData(conversions, plasmaJoinsArray, rewards), _parseCampaignData2 = _slicedToArray(_parseCampaignData, 3), revJoinsByPlasma = _parseCampaignData2[0], users = _parseCampaignData2[1], campaignLastActivityAfterPublicResponse = _parseCampaignData2[2];
                  _visitedListFromGraph = visitedListFromGraphToHashMap(firstReferrerInfo, visitArray, revJoinsByPlasma, users, campaignLastActivityAfterPublicResponse), _visitedListFromGraph2 = _slicedToArray(_visitedListFromGraph, 4), hashmapEdges = _visitedListFromGraph2[0], mutatedUsers = _visitedListFromGraph2[1], campaignLastActivityAfterPrivateResponse = _visitedListFromGraph2[2], visitsSubstruction = _visitedListFromGraph2[3];
                  _buildSubGraphWrapper = buildSubGraphWrapper(campaignWeb3Address, mutatedUsers, hashmapEdges), _buildSubGraphWrapper2 = _slicedToArray(_buildSubGraphWrapper, 3), buildSG = _buildSubGraphWrapper2[0], hoverByPlasma = _buildSubGraphWrapper2[1], stats = _buildSubGraphWrapper2[2];
                  refGraphD3Input = buildSG(nodeToBuildGraphFrom, 1);
                  refMapNodeCounter = stats.refMapNodeCounter.counter;
                  paidClicksDownstream = stats.paidClicksDownstream.counter;
                  unpaidClicksDownstream = stats.unpaidClicksDownstream.counter;
                  approvedClicksDownstream = paidClicksDownstream + unpaidClicksDownstream;
                  referrersDownstream = hoverByPlasma[nodeToBuildGraphFrom] && hoverByPlasma[nodeToBuildGraphFrom].referrersDownstream;
                  rejectedConversionsDownstream = stats.rejectedConversions.counter;
                  maxChainLength = stats.maxChainLength.counter;
                  conversionsDownstream = stats.conversionsDownstream.counter;
                  nodesCounterFromGraph = plasmaVisits + 1 - visitsSubstruction;

                  if (process.env.EXECUTION_CONTEXT) {
                    console.log("Output values: numberOfRefMapNodes-".concat(refMapNodeCounter, ", numberOfRefMapNodesFromGraph-").concat(nodesCounterFromGraph, "."));
                  }

                  ;
                  resolve({
                    normalTree: refGraphD3Input,
                    maxChainLength: maxChainLength,
                    hoverByPlasma: hoverByPlasma,
                    amountOfNodes: visitArray.length,
                    campaignLastActivity: campaignLastActivityAfterPrivateResponse,
                    numberOfRefMapNodes: refMapNodeCounter,
                    numberOfRefMapNodesFromGraph: nodesCounterFromGraph,
                    synced: refMapNodeCounter.counter == nodesCounterFromGraph,
                    referrersDownstream: referrersDownstream,
                    rejectedConversionsDownstream: rejectedConversionsDownstream,
                    conversionsDownstream: conversionsDownstream,
                    paidConversionsDownstream: paidClicksDownstream,
                    unpaidConversionsDownstream: unpaidClicksDownstream,
                    approvedConversionsDownstream: approvedClicksDownstream // Paid Unpaid and Approved conversions added so FE will deal with all campaign conversions is the same manner

                  }); // resolve({ plasmaResponse, publicResponse });

                  _context.next = 58;
                  break;

                case 55:
                  _context.prev = 55;
                  _context.t0 = _context["catch"](6);
                  reject(_context.t0);

                case 58:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[6, 55]]);
        }));

        return function (_x, _x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }]);

  return ReferralMap;
}();
/* eslint-enable no-underscore-dangle */


module.exports = ReferralMap;